import _ from 'lodash';
import {
  FETCH_USER_CARRIER_SELECTIONS_SUCCESS,
  SAVE_USER_CARRIER_SELECTION_REQUEST,
  DELETE_USER_CARRIER_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import carriersMapper from '../mappers/carriersMapper';
import {
  CARRIER_CHECKED,
  DESELECT_ALL_CARRIERS,
  RETRIEVE_OUTBOUND_CARRIER_REQUEST,
  RETRIEVE_OUTBOUND_CARRIER_SUCCESS,
  RETRIEVE_OUTBOUND_CARRIER_FAILURE,
  SELECT_ALL_CARRIERS,
} from '../actions/types/CarrierActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import filterCarriersIfExistsInPostalOperator from '../filters/filterCarriersIfExistsInPostalOperator';

export const initialState = {
  nodes: [],
  carriers: [],
  selections: [],
  checkedCarriers: [],
  isLoading: false,
};

const handleUserCarrierSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    carriers: action.payload.selectedCarriers,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserCarrierSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const carrierReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_CARRIER_SELECTIONS_SUCCESS:
      return {
        ...state,
        selections: [...action.payload.selections]
          .map(selection => ({
            ...selection,
            name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
          }))
          .sort((a, b) => a.name.localeCompare(b.name)),
      };
    case RETRIEVE_OUTBOUND_CARRIER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RETRIEVE_OUTBOUND_CARRIER_SUCCESS:
      return {
        ...state,
        nodes: carriersMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_OUTBOUND_CARRIER_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case CARRIER_CHECKED:
      return {
        ...state,
        checkedCarriers: filterCarriersIfExistsInPostalOperator(
          action.checkedCarriers,
          state.nodes,
        ),
      };
    case SELECT_ALL_CARRIERS:
      return {
        ...state,
        checkedCarriers: action.payload.nodes.map(node => node.value),
      };
    case DESELECT_ALL_CARRIERS:
      return {
        ...state,
        checkedCarriers: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_CARRIER_SELECTION_REQUEST:
      return handleUserCarrierSelectionRequest(action, state);
    case DELETE_USER_CARRIER_SELECTION_REQUEST:
      return handleUserCarrierSelectionDeleteRequest(action, state);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
